"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.konfektionierungJson = void 0;
const KonfektionierungModel_1 = require("./KonfektionierungModel");
exports.konfektionierungJson = {
    EntityId: '1508954445171_947859',
    Typ: KonfektionierungModel_1.KonfektionierungTyp.auftrommelnRatePerMeter,
    ArtNrExists: true,
    ArtNrGenerated: 'KONFEKTIONIERUNG',
    BasePriceVK: { Countries: { DE: { EUR: 44.025940000000006 } } },
};
//# sourceMappingURL=konfektionierungJson.js.map